export const isActivePath = (pathname, target) =>
  !!target && (pathname === target || pathname.startsWith(`${target}/`));